import React from "react";
import PropTypes from "prop-types";
import {Button} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import {SVPUpgradeSubscriptionIcon} from "../ToolTip/SVPUpgradeSubscriptionIcon";

export const SVPSubmitButton = ({
    isLoading, // this is revered
    onClick,
    className,
    buttonText = "Save",
    buttonLoadingText = "Saving...",
    disabled = false,
}) => {
    const buttonStyles = {
        opacity: disabled ? 0.5 : 1,
        cursor: disabled ? "not-allowed" : "pointer",
    };

    return <>
        {isLoading ?
            <Button
                style={buttonStyles}
                className={className}
                type="submit"
                onClick={disabled ? null : onClick}
                variant="contained"
                endIcon={disabled ?
                    <SVPUpgradeSubscriptionIcon message={"Upgrade to create more Inspections"} /> :
                    <SaveIcon />}
            >
                {buttonText}
            </Button> :
            <Button
                variant="outlined"
                className={className}
                id="loadingBtn"
                disabled={true}
            >
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                {buttonLoadingText}
            </Button>
        }
    </>;
};

SVPSubmitButton.propTypes = {
    isLoading: PropTypes.bool,
    onClick: PropTypes.func,
    buttonText: PropTypes.string,
    buttonLoadingText: PropTypes.string,
    className: PropTypes.string,
    disabled: PropTypes.bool,
};
